import styled from 'styled-components';

export const CloseBackGround = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 90;
  background: #00000059;
`;

export const Container = styled.div`
  position: fixed;
  bottom: 0px;
  left: 0;
  right: 0;
  top: 10%;
  z-index: 100;
  background: ${(props) => props.theme.serviceDeskMainBackground};
  border-radius: 4px;
  box-shadow: 0px 0.15px 0.45px 0px rgba(0, 0, 0, 0.11),
    0px 0.8px 1.8px 0px rgba(0, 0, 0, 0.13);
`;

export const InnerContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ScrollableContainer = styled.div`
  overflow-y: auto;
  height: 100%;
  padding-bottom: 10px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  padding: 16px;
`;

export const Title = styled.h1`
  text-align: center;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.43px;
`;

export const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FilterOptionTitle = styled.h2`
  font-size: 14px;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  color: ${(props) => props.theme.serviceDeskTextColorTertiary};
`;

export const DropdownContainer = styled.div`
  position: relative;
`;

export const DropDownWrapper = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr max-content;
  grid-template-rows: auto;
  grid-template-areas: 'input icon';
  border: 1px solid transparent;
  border-radius: 4px;
  padding: 6px 10px;
  background: ${(props) => props.theme.serviceDeskInputBackground};
  cursor: pointer;
  position: relative;
  &.hasFilters {
    border-bottom: 2px solid
      ${(props) => props.theme.serviceDeskColorButtonRest};
  }
`;

export const DropDownBar = styled.div`
  grid-area: input;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 5px;
  border: none;
  word-wrap: break-word;
  word-break: break-all;
  position: relative;
`;

export const DropDownPlaceholder = styled.span`
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  color: ${(props) => props.theme.serviceDeskTextColorSecondary};
`;

export const SelectedCheckboxLabel = styled.span`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: ${(props) => props.theme.serviceDeskTextColorPrimary};
`;

export const DropDownIcon = styled.div`
  grid-area: icon;
  width: 20px;
  height: 20px;
  font-size: 20px;
  cursor: pointer;
  width: auto;
  align-self: flex-start;
`;

export const DropDownOptionsWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  padding: 0px 4px;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 100;
  background: ${(props) => props.theme.serviceDeskInputDropDownBackground};
  border-radius: 4px;
  box-shadow: 0px 0.15px 0.45px 0px rgba(0, 0, 0, 0.11),
    0px 0.8px 1.8px 0px rgba(0, 0, 0, 0.13);
  max-height: 200px;
  overflow-y: auto;
`;
